import React, { useEffect, useState } from "react";
import { BouncingLoader } from '../../pure-components/Loader';

import { ErrorToast, SuccessToast, WarningToast } from '../../pure-components/CustomToast';
import { toast } from 'react-toastify';

import "./style.css";
import API from "../../services/api";
import Validator from "../../services/validator";
import axios from "axios";
import Helper from "../../services/helper";
import CookieManager from "../../services/CookieManager";
function Login () {
    const validator = new Validator();
    const [userData, setUserData] = useState({
        email : "",
        password : "",
    })
    const [helperText, setHelperText] = useState({});
    const [isDisabled, setIsDisabled] = useState(true);
    const [signingIn, setSigningIn] = useState(false);
    
    const [paymentForm, setPaymentForm] = useState("");

    const params = new URLSearchParams(window.location.search);
    const status = params.get("status");
    
    useEffect(() => {

      if(status){
        //signing out, while redirected after payment processing.
        Helper.signOut();
        
        status === "Success" ? 
        toast(({ closeToast }) => <SuccessToast message={"Subscribed successfully. Login to continue."}/>) : 
        toast(({ closeToast }) => <WarningToast message={"Subscription pending. Login to continue."}/>);
      }
    }, [])

    const handleInputChange = (e, key) => {
        let value = key === 'tos' ? e : e.target.value;
        if (key === 'email') {
          let res = validator.setValue(value, 'Email ').isNotEmpty().isEmail();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        if (key === 'password') {
          let res = validator.setValue(value, 'Password ').isNotEmpty().isString();
          let temp = {...helperText};
          temp[key] = res.mssg;
          setHelperText(temp);
        }
        if(helperText['email']?.length > 0 || helperText['password']?.length > 0)
          setIsDisabled(true);
        else
          setIsDisabled(false)
    
        let tempUserData = {...userData};
        tempUserData[key] = value;
        setUserData(tempUserData);
    };
    
    const handleSignIn = async() => {
        let counter = 0;
        let temp = {...helperText};
        let resEmail = new Validator(userData.email, 'Email ').isNotEmpty().isString();
        temp['email'] = resEmail.mssg;
        resEmail.status === false && counter++;
        let resValidator = new Validator(userData.password, 'Password ').isNotEmpty().isString();
        temp['password'] = resValidator.mssg;
        resValidator.status === false && counter++;
        setHelperText(temp);
        if(counter > 0){
          setIsDisabled(true);
          return;
        }
        // console.log({helperText});
        let payload = { email: userData.email?.toLowerCase(), password: Helper.encode(userData.password) };
        if (counter === 0) {
          setIsDisabled(true);
          setSigningIn(true);
        
          await API.logIn(payload).then(res => {
            setIsDisabled(false);
            // console.log('[USER LOGGED IN]',JSON.stringify(res));
            if (!res?.success) {
              toast(({ closeToast }) => <ErrorToast message={res.mssg}/>);
              setSigningIn(false)
            }else{
              const tempData = res.data ? res.data : {};

              localStorage.setItem("favs", JSON.stringify(tempData?.favorites));
              localStorage.setItem("history", JSON.stringify(tempData?.history));
              localStorage.setItem("resourceURL", JSON.stringify(tempData?.resourceURL));

              delete tempData?.favorites;
              delete tempData?.history;
              delete tempData?.resourceURL;
              CookieManager.setCookie("user-data", JSON.stringify(tempData));

              let targetLocation = CookieManager.getCookie("target-location");
              if(targetLocation?.length){
                window.location = targetLocation;
                CookieManager.deleteCookie("target-location");
              }else if(res.data.userType === "SUPER_ADMIN" || res.data.userType === "ADMIN")
                window.location.pathname = "/admin";
              else
                window.location.pathname = "/projects";

            }
          })
          .catch((err) => {
            console.log("Sign In Error : ", err);    
            let msg = err.mssg;
            if(err.mssg.indexOf("Not Activated") > -1)
              msg += ". Please contact your Admin."
            toast(({ closeToast }) => <ErrorToast message={msg}/>);
            setSigningIn(false);
            setIsDisabled(false);
          });
        }
    }

    const pay = async() => {
        try {
          const orderData = {
            // access_code: accessCode,
            merchant_id: "3117229",
            order_id: "a1b2c3d4",
            amount: 100,
            currency: 'INR',
            redirect_url: "localhost:3000/home",
            cancel_url: "localhost:3000/home",
            billing_name: "test",
            billing_email: "jktri95@gmail.com",
            billing_tel: '1234567890',
            billing_address: 'Test Address',
            billing_city: 'Mumbai',
            billing_state: 'Maharashtra',
            billing_zip: '400001',
            billing_country: 'India',
            delivery_name: "test",
            delivery_address: 'Test Delivery Address',
            delivery_city: 'Mumbai',
            delivery_state: 'Maharashtra',
            delivery_zip: '400001',
            delivery_country: 'India',
        };
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}api/payment/initiate`, {}).then(res => {
              console.log("form data response : ", res);
              return res;
            });
            // const response = await axios.post(`localhost:3001/ccavRequestHandler`, orderData).catch((err) => {
            //   console.log("Error : ", err)
            // });
            // document.body.innerHTML = response.data;  // Insert the form into the DOM to automatically submit to CCAvenue
            
            // setPaymentForm(response.data);
            const formContainer = document.createElement('div');
            formContainer.innerHTML = response.data;
            document.body.appendChild(formContainer);
            
            const form = document.getElementById('paymentForm');
            form.submit();
          } catch (error) {
            console.error('Payment initiation failed:', error);
          }
    }

    // useEffect(()=> {
    //   console.log("useEffect paymentForm : ", paymentForm)
    //   // if(paymentForm?.length > 0){
    //   //   const form = document.createElement(paymentForm);
    //   //   form.submit();

    //   //   setPaymentForm("");
    //   // }
    // }, [paymentForm])
    const submitForm = () => {
        if (paymentForm) {
            // document.paymentForm?.submit();
          const formElement = document.getElementById('paymentForm');
          console.log("paymentForm Data : ", paymentForm, formElement);
          if (formElement) {
            formElement.submit();
          }
        }
      };
  return (
    <div className="w-full mt-10 lg:px-20 flex flex-wrap canvas">

        <div className="w-full justify-center flex">
        {signingIn ?
            <div className='w-full'>
            <div className='w-full pt-20 pb-10'>
                <BouncingLoader />
                <span className='w-full flex justify-center text-green-500'><b>Signing In, Please Wait...</b></span>
            </div>
            </div>
            :
            <div className="lg:w-1/2 sm:w-full flex flex-wrap mt-16 mb-10 rounded-2xl box" >
                <div className="w-full flex rounded-2xl">
                  <div className="w-full pl-12 my-2">
                    <div className="w-full py-4">
                        <span className="w-full flex header-text">
                            Log In
                        </span>
                    </div>
                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Email address
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-full self-center input-field rounded-full py-2 mr-16` }
                                type="text"
                                placeholder="Email *"
                                value={userData.email}
                                onChange={(e) => handleInputChange(e, 'email')}
                                onBlur={(e) => handleInputChange(e, 'email')}     
                            />
                        </span>
                        <span className="w-full flex">
                            <p className="helper-text-red pl-1">{helperText.email}</p>
                        </span>
                       
                    </div>

                    <div className="w-full pb-2">
                        <span className="w-full flex field-title">
                            Password
                        </span>
                        <span className="w-full flex">
                            <input
                                className={`w-full self-center input-field rounded-full py-2 mr-16` }
                                type="password"
                                placeholder="Password *"
                                value={userData.password}
                                onChange={(e) => handleInputChange(e, 'password')}
                                onBlur={(e) => handleInputChange(e, 'password')}
                            />
                        </span>
                       
                    </div>

                    
                    <div className="w-full pb-2">
                        <span className="w-full flex pr-14">
                            <button className={`${isDisabled ? "btn-disabled" : "btn-pink"}`} 
                            onClick={() => {handleSignIn()}}
                            disabled={isDisabled}> LOG IN </button>
                        </span>
                    </div>
                    <div className="w-full pb-2 flex">
                        <span className="lg:w-1/2 sm:w-full flex justify-start">
                            <p className="pr-4">Don't have an account? <a className="link-text cursor-pointer" href={process.env.REACT_APP_MKT_SITE_PRICING}><b>Sign Up</b> </a></p>
                        </span>
                        <span className="lg:w-1/2 sm:w-full flex justify-end mr-16">
                            <a className="lg:title-text sm:text-sm cursor-pointer" href={'/forgot-password'}><b>Forgot Password?</b> </a>
                        </span>
                    </div>
                    <div className="w-full pb-5">
                        <hr className="w-11/12 flex" />
                    </div>
                    
                    {/* <div className="w-full pb-2">
                        <span className="w-full flex pr-14">
                            <button className={`btn`} 
                            onClick={() => {pay()}}
                           > Pay </button>
                        </span>
                    </div> */}
                    {paymentForm && (
                        <div>
                        <div
                            id="paymentFormContainer"
                            dangerouslySetInnerHTML={{ __html: paymentForm }}
                            onLoad={submitForm()}
                        />
                        {/* Trigger form submission once it's rendered */}
                        
                        </div>
                    )}
                  </div>
                </div>
            </div>
        }
        </div>
        
    </div>
  );
}

export default Login;